// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__WCB6R","empty":"ModalGraph_empty__1pEKJ"};